import React, { useState, useEffect, useRef, Fragment } from "react"
import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, Button, TextField, Typography, Tooltip, IconButton, Dialog, Paper } from "@material-ui/core"
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined"
import InfoIcon from '@material-ui/icons/Info'
import Autocomplete from "@material-ui/lab/Autocomplete"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { getAircraftDetailApi } from "./apiServices"
import { checkApiStatus, permissionCheckFnforCamo } from "../../../src/utils"
import { withSnackbar } from "notistack"
import { connect } from "react-redux"
import moment from 'moment'
import RefreshIcon from "@material-ui/icons/Refresh"
import { getAircraftTypesAc, getEngineTypesAc, getLesseeListAc, getOperatorListAc, getRegionListAc, getPlatformConstantsAc, getPortfolioListAc, getAircraftMntProgramAc, getLeaseStatus, getSubStatus, getAllAssetListAc } from "../../shared_elements/actionCreators"
import { trackActivity } from "../../utils/mixpanel"
import BasicDetailForm from "./BasicDetailForm"
import { isMobile } from "react-device-detect"
import EngineDetailForm from "./EngineDetailForm"
import { getLocalStorageInfo, Comma_format, downloadFileType } from "../../../src/utils"
import { dayMonthDateFormat, fieldDMYShort } from "../../constants"
import { moduleName } from "../../constants"
import { smbcInstance, acumenCamo } from "../../shared_elements/components"
import TechSpecListing from "./TechSpecListing"
import EngOnOffWingList from "./EngOnOffWingList"
import { withRouter } from 'react-router-dom/cjs/react-router-dom'
import { DeletePopUp, PageLoader } from "../../shared_elements"
import DownloadXLSAssetDetail from "../../shared_elements/DownloadXLSAssetDetail"
import { onArchiveAsset } from "./ad/apiService"
import { engineDetailObj, offWingObj } from '.'
import { globalGetService, globalExportService } from "../../utils/globalApiServices"
import SubDetails from "../../shared_elements/components/sub_details/SubDetails"
const BasicDetailHeader = (props) => {
	const [headerData, setHeaderData] = useState({})
	const [LHData, setLHData] = useState({})
	const [RHData, setRHData] = useState({})
	const [openEditForm, setOpenEditForm] = useState(false)
	const [openEditFormEngine, setOpenEditFormEngine] = useState(false)
	const [ownersList] = useState([])
	const [basicDetailData, setBasicDetailData] = useState({})
	const [btnTypes, setBtnTypes] = useState('')
	const [pageLoader, setPageLoader] = useState(false)
	const [archiveModal, setArchiveModal] = useState(false)
	const basicDetailDataRef = useRef({})
	const didMountRef = useRef(false)

	const { asset, assetType } = props?.match?.params
	const { portfolios, aircraftTypes, pltConstants, lessees, operators, aircraftMntGrp, leaseStatus, subStatus, svData, allAssets,} = props
	const getTechSpecDetail = (data) => {
		//  props?.location?.pathname.split("/").at(-2) !== 'tech_spec' ? setPageLoader(false) : 
		 setPageLoader(true)
		globalGetService(`camo/engine_tech_spec/${data?.slug}/details/`)
			.then(response => {
				if (checkApiStatus(response)) {
					setPageLoader(false)
					setBasicDetailData(response?.data?.data)
					basicDetailDataRef.current = response?.data?.data
				} else {
					setPageLoader(false)
				}
			})
	}

	const mainHeaderData = async () => {
		try {
			const response = await getAircraftDetailApi(props, '', (val) => setPageLoader(val))
			const data = response.data.data
			getTechSpecDetail(data)

			if (data) {
				const tempLHdata = data.engine_detail?.length > 0 ? data.engine_detail.find((x) => x.position.value === 1 || x.position.value === 3) : {}
				if (tempLHdata) {
					setLHData(tempLHdata)
				}

				const tempRHdata = data.engine_detail?.length > 0 ? data.engine_detail.find((x) => x.position.value === 2 || x.position.value === 4) : {}
				if (tempRHdata) {
					setRHData(tempRHdata)
				}
			}

			setHeaderData(data)

			if (props?.location?.pathname.split("/").at(-2) !== 'tech_spec') {
				props.func(data.slug, data.tsn, data.csn, data.date_of_manufacture, data?.thrust_details)
				props.uuid?.(data?.record_folders?.technical_records)
			}

			if (props.module === 'util' || props.module === 'Op' ||
				props.module === 'ad' || props.module === 'sb' ||
				props.module === 'inventory' || props.module === 'st' ||
				props.module === 'mc' || props.module === 'llp' ||
				props.module === 'sv' || props.module === 'eng_module' ||
				props.module === 'occm' || props.module === 'sr' ||
				props.module === 'amp' || props.module === 'ht' ||
				props.module === 'mods')  {
				props.engineType?.(data)
			}
			

			setTimeout(() => {
				const latestBasicDetailData = basicDetailDataRef.current
				if (props.module === 'util') {
					props.engineType(data, latestBasicDetailData)
				}
				if (props.module === 'sv') {
					props.basicData(data, latestBasicDetailData)
				}
			}, 2000)

		} catch (error) {
			console.error("Error in mainHeaderData:", error)
		}
	}

	useEffect(() => {
		mainHeaderData()
		props.getPlatformConstants()
		props.getLesseeList()
		props.getOperatorList()
		props.getRegionList()
		props.getPortfolioList()
		props.getEngineTypes()
		props.getAircraftTypes()
		props.getLeaseStatus()
		props.getSubStatus()
		trackActivity("Page Visited", {
			page_title: "Camo Technical Specification",
		})
		if (!props.allAssets.length) {
			props.getAllAssetListFn()
		}
	}, [])

	// Re-fetch the aircraft/engine detail whenever a module (e.g. Utilization)
	// performs an add/update/delete and bumps the refresh token in the store,
	// so the header engine data (TSN/CSN/TSPR/CSPR/Reporting Month) stays in sync.
	useEffect(() => {
		if (!didMountRef.current) {
			didMountRef.current = true
			return
		}
		mainHeaderData()
	}, [props.basicDetailRefreshToken])

	const handleEditRow = () => {
		setOpenEditForm(true)
	}

	const closeUpdateForm = () => {
		setOpenEditForm(false)
	}

	const changeAssetSwitcher = async (value) => {
		let assettype = props.allAssets.find(asset => asset?.slug === value?.slug)
		const response = await getAircraftDetailApi(props, value, (val) => setPageLoader(val))
		if (response) {
			if (props?.module) {
				if (props?.history) {
					props?.history.push(`/${response?.data?.data?.id}/${assettype?.asset_type}/${moduleName[props?.module]}/list`)
				} else {
					window.location.replace(`/${response?.data?.data?.id}/${assettype?.asset_type}/${moduleName[props?.module]}/list`)
				}
				// props?.props.history.push(`/${response?.data?.data?.id}/${assettype?.asset_type}/${moduleName[props?.module]}/list`)
			} else {
				if (props?.history) {
					props?.history.push(`/${response?.data?.data?.id}/${assettype?.asset_type}/tech_spec/list`)
				} else {
					window.location.replace(`/${response?.data?.data?.id}/${assettype?.asset_type}/tech_spec/list`)
				}
			}
		}
		setTimeout(() => { window.location.reload(false) }, 500)
	}

	const tecSpecEditFn = (type) => {
		setOpenEditFormEngine(true)
		setBtnTypes(type)
	}

	const exportMasterApiWrapper = (queryParams) => {
		setPageLoader(true)
		const date = new Date()
		const todayeDate = moment(String(date)).format("DD-MM-YYYY")
		const { asset, assetType } = props.match.params
		delete queryParams.asset_type
		globalExportService(`/camo/smbc_master_excel/${asset}/${assetType}/export/`)
			.then((response) => {
				if (response.status === 500) {
					props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } })
				} else {
					setPageLoader(false)
					downloadFileType(response.data, `Master_Export_${todayeDate}`, queryParams.download)
					props.enqueueSnackbar("Master Export Download Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } })
					trackActivity("Master Export", { page_title: "Master Export" })
				}
			})
	}

	const selectedAsset = allAssets.find(asset => asset?.slug === basicDetailData?.slug && asset?.asset_type == assetType)

	return (
		<Fragment>
			<Grid container spacing={1} style={{ marginTop: props?.location?.pathname.split("/").at(-2) === 'tech_spec' ? '5px' : '' }}>
				{props?.location?.pathname.split("/").at(-2) === 'tech_spec' && <Grid  xs={12} item>
					<SubDetails
						masterExport={true}
						title="Technical Specification"
						slug={basicDetailData?.slug}
						match={props?.match}
						onRefresh={() => mainHeaderData()}
						permissionCheck={permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" })}
					/>
				</Grid>}
				{/* <Grid item xs={12}>
			    {props?.location?.pathname.split("/").at(-2) === 'tech_spec' &&<Paper elevation={1} square style={{padding: '5px 10px', marginBottom: '10px', background: '#fbfbfb', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
						{assetType != 1 &&
							<div style={{ flex: '1 1 200px', minWidth: '160px', maxWidth: '320px' }}>
								<Autocomplete
									options={allAssets || []}
									disabled={!basicDetailData?.slug}
									getOptionLabel={(option) => option?.unique_name}
									value={selectedAsset ? selectedAsset : ''}
									onChange={(e, value) => value ? changeAssetSwitcher(value) : e.preventDefault()}
									renderInput={params => <TextField {...params} margin="none" variant='outlined' size="small" fullWidth InputLabelProps={{ shrink: true }} disabled={!basicDetailData?.slug} />}
								/>
							</div>
						}
						{props?.location?.pathname.split("/").at(-2) === 'tech_spec' &&
							<div className="export-list" style={{ display: 'flex', alignItems: 'center' }}>
								<DownloadXLSAssetDetail variant="outlined" size='large' files={{ title: "Master Export", extension: "xlsx", key: "" }} exportReportFn={(file) => exportMasterApiWrapper({ download: file.extension })} style={{ color: "#bd10e0" }} />
							</div>
						}
						{props?.location?.pathname.split("/").at(-2) === 'tech_spec' && permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" }) &&
							<div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginLeft: 'auto' }}>
								<Tooltip title={props?.location?.search === '?archived-assets' ? 'ARCHIVE' : "ARCHIVE ASSET"} arrow placement="top">
									<Button
										onClick={() => props?.location?.search !== '?archived-assets' && setArchiveModal(true)}
										color={props?.location?.search === '?archived-assets' ? 'black' : 'primary'}
										size='large' variant='outlined'
										style={{ background: props?.location?.search === '?archived-assets' && 'linear-gradient(269deg, #e1e1e1, #b3b3b3)' }}>
										{props?.location?.search === '?archived-assets' ? 'ARCHIVE' : 'ARCHIVE ASSET'}
									</Button>
								</Tooltip>
								<Tooltip title="Refresh" arrow placement="top">
									<IconButton className="p-5px" color="primary" onClick={() => mainHeaderData()}>
										<RefreshIcon />
									</IconButton>
								</Tooltip>
							</div>
						}
					</Paper>}
				</Grid> */}
			</Grid>
			<div id="AmpTableHeader">
				<Accordion defaultExpanded onChange={(_, expanded) => props.onAccordionChange?.(expanded)}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon className="p-5" />}
						aria-controls="panel1a-content"
						id="panel1a-header"
					>
						<Typography>Basic Details</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<Grid container>
							<Grid
								className="left-panel"
								item
								xs={12}
								style={{ backgroundColor: "#efefef", position: 'relative' }}
							>
								{window?.location?.search.includes('archived-assets') ? null : getLocalStorageInfo()?.user?.security_groups?.find(item => item?.id === 29) ?
									<div id="edit-basic-detail" style={{ position: 'absolute', top: 4, right: 4, zIndex: 1 }}>
										<Tooltip title="Edit" arrow placement="top">
											<IconButton
												className="edit-asset-icon"
												onClick={(e) => { handleEditRow(e) }}
											>
												<CreateOutlinedIcon />
											</IconButton>
										</Tooltip>
									</div> : null}

								{/* Section 1 — Primary Details */}
								<Grid container spacing={2} style={{ padding: '12px 12px 8px' }}>
									<Grid item xs={6} sm={4} md={2}>
										<Typography style={{fontWeight:"bold"}} variant="caption" display="block">
											{assetType == 1 ? "Aircraft Type/Model" : "Engine Type/Model"}
										</Typography>
										<Typography variant="body2">
											{assetType == 1 ? headerData?.aircraft_type_name : headerData.engine_type_name}
										</Typography>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<Typography style={{fontWeight:"bold"}} variant="caption" display="block">
											{assetType == 1 ? "MSN" : "ESN"}
										</Typography>
										<Typography variant="body2">
											{assetType == 1 ? headerData?.msn : headerData?.esn}
										</Typography>
									</Grid>
									{assetType == 1 && (
										<Grid item xs={6} sm={4} md={2}>
											<Typography style={{fontWeight:"bold"}} variant="caption" display="block">Registration</Typography>
											<Typography variant="body2">
												{headerData.current_registration_number ? headerData.current_registration_number : " -- "}
											</Typography>
										</Grid>
									)}
									<Grid item xs={6} sm={4} md={2}>
										<Typography style={{fontWeight:"bold"}} variant="caption" display="block">Date of Manufacture</Typography>
										<Typography variant="body2">
											{headerData.date_of_manufacture ? moment(headerData.date_of_manufacture).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : " -- "}
										</Typography>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<Typography style={{fontWeight:"bold"}} variant="caption" display="block">
											{assetType == 1 ? "A/C TSN" : "Engine TSN"}
										</Typography>
										<Typography variant="body2">
											{headerData.tsn >= 0 ? Comma_format((headerData.tsn).toFixed(2)) : "--"}
										</Typography>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<Typography style={{fontWeight:"bold"}} variant="caption" display="block">
											{assetType == 1 ? "A/C CSN" : "Engine CSN"}
										</Typography>
										<Typography variant="body2">
											{headerData.csn >= 0 ? Comma_format(parseInt(headerData.csn)) : "--"}
										</Typography>
									</Grid>
								</Grid>

								{/* Section 2 — Aircraft: engine positions | Engine: performance limits */}
								{assetType == 1 && (
									<>
										{/* <Divider /> */}
										<Grid container spacing={2} style={{ padding: '8px 12px 12px' }}>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">LH Engine Type(Serial No)</Typography>
												<Typography variant="body2">
													{LHData?.engine_type?.name ? `${LHData?.engine_type?.name + " "}(${LHData?.esn})` : " -- "}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">LH Engine TSN</Typography>
												<Typography variant="body2">
													{LHData && LHData.tsn ? Comma_format(LHData.tsn) : " -- "}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">LH Engine CSN</Typography>
												<Typography variant="body2">
													{LHData && LHData.csn ? Comma_format(parseInt(LHData.csn)) : " -- "}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">RH Engine Type/Serial No</Typography>
												<Typography variant="body2">
													{RHData?.engine_type?.name ? `${RHData?.engine_type?.name + " "}(${RHData?.esn})` : " -- "}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">RH Engine TSN</Typography>
												<Typography variant="body2">
													{RHData && RHData.tsn ? Comma_format(RHData.tsn) : " -- "}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">RH Engine CSN</Typography>
												<Typography variant="body2">
													{RHData && RHData.csn ? Comma_format(RHData.csn) : " -- "}
												</Typography>
											</Grid>
										</Grid>
									</>
								)}
								{assetType == 2 && (
									<>
										{/* <Divider /> */}
										<Grid container spacing={2} style={{ padding: '8px 12px' }}>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">
													{smbcInstance ? 'TSPR' : 'TSLSV'}
												</Typography>
												<Typography variant="body2">
													{headerData?.tslv > 0 ? Comma_format((headerData?.tslv).toFixed(2)) : 0}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">
													{smbcInstance ? 'CSPR' : 'CSLSV'}
												</Typography>
												<Typography variant="body2">
													{headerData?.cslv > 0 ? Comma_format(parseInt(headerData?.cslv)) : 0}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">LLP Limiter(s)</Typography>
												<Typography variant="body2">
													{headerData?.llp_limiter > 0 ? Comma_format(parseInt(headerData?.llp_limiter)) : headerData?.llp_limiter === null ? 'N/A' : 0}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">Soft-time Limiter(s)</Typography>
												<Typography variant="body2">
													{headerData?.soft_time_limiter > 0 ? Comma_format(parseInt(headerData?.soft_time_limiter)) : headerData?.soft_time_limiter === null ? 'N/A' : 0}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">Op. Thrust (Current)</Typography>
												<Typography variant="body2">
													{headerData?.current_operating_thrust?.name ? headerData?.current_operating_thrust?.name : " -- "}
												</Typography>
											</Grid>
										</Grid>
										{/* <Divider /> */}
										<Grid container spacing={2} style={{ padding: '8px 12px 12px' }}>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">
													Reporting Month&nbsp;
													<Tooltip title="Update (Utilization As of Date)" placement="top" arrow>
														<InfoIcon size='small' style={{ verticalAlign: 'middle', fontSize: "small" ,color:'#0000008a'}} />
													</Tooltip>
												</Typography>
												<Typography variant="body2">
													{headerData?.last_utilization_updated ? moment(headerData?.last_utilization_updated).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : " -- "}
												</Typography>
											</Grid>
											{props?.location?.pathname.split("/").at(-2) === 'tech_spec' ? null : <><Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">MCBR</Typography>
												<Typography variant="body2">
													{basicDetailData?.new_tec_spec?.smbc_forecast_mcbr  || " -- "}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">MTBR</Typography>
												<Typography variant="body2">
													{basicDetailData?.new_tec_spec?.smbc_forecast_mtbr || " -- "}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">SV Interval Remaining</Typography>
												<Typography variant="body2">
													{basicDetailData?.new_tec_spec?.sv_interval_remaining === null ? "N/A" : basicDetailData?.new_tec_spec?.sv_interval_remaining > 0 ? basicDetailData?.new_tec_spec?.sv_interval_remaining : '0'}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">SV Forecast Date</Typography>
												<Typography variant="body2">
													{basicDetailData?.new_tec_spec?.sv_forecast_date ? moment(basicDetailData?.new_tec_spec?.sv_forecast_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "N/A"}
												</Typography>
											</Grid>
											<Grid item xs={6} sm={4} md={2}>
												<Typography style={{fontWeight:"bold"}} variant="caption" display="block">Operator</Typography>
												<Typography variant="body2">
													{headerData?.operator?.name || " -- "}
												</Typography>
											</Grid>
											<Grid item xs={12}>
												<EngOnOffWingList basicDetailData={basicDetailData} />
											</Grid></>}
										</Grid>
									</>
								)}
							</Grid>
						</Grid>
					</AccordionDetails>
				</Accordion>
			</div>
			{props?.location?.pathname.split("/").at(-2) !== 'tech_spec' ? null :
				<TechSpecListing assetType={assetType} basicDetailData={basicDetailData} assetsDetail={props?.assetsDetail} tecSpecEdit={tecSpecEditFn} />
			}
			{openEditForm && <BasicDetailForm
				open={openEditForm}
				closeUpdateForm={closeUpdateForm}
				getResponseBack={mainHeaderData}
				fetchMntGrops={(aircraftId) => props.getAircraftMntProgram(aircraftId)}
				aircraftMntGrp={aircraftMntGrp}
				leaseStatus={leaseStatus}
				subStatus={subStatus}
				portfolios={portfolios}
				ownersList={ownersList}
				lessees={lessees}
				operators={operators}
				pltConstants={pltConstants}
				aircraftTypes={aircraftTypes}
				headerData={headerData}
				asset={asset}
				LHData={LHData}
				RHData={RHData}
				assetType={assetType}
				basicDetailData={basicDetailData}
				props={props}
			/>}
			<Dialog
				position="relative"
				maxWidth="lg"
				open={openEditFormEngine}
				style={{ height: isMobile && "650px" }}
				className="engine-tech-spec"
			>
				<EngineDetailForm
					closeUpdateForm={() => setOpenEditFormEngine(false)}
					slug={headerData.slug}
					basicDetailData={basicDetailData}
					getResponseBack={() => getTechSpecDetail(headerData)}
					assetDetail={headerData}
					assets={props.assetsDetail}
					svData={svData}
					pltConstants={pltConstants}
					btnTypes={btnTypes}
				/>
			</Dialog>
			{props?.location?.pathname.split("/").at(-2) !== 'tech_spec' ? null : pageLoader ? <PageLoader /> : null}
			{archiveModal ?
				<DeletePopUp
					title='Archive Asset'
					deleteRecordFn={() => onArchiveAsset(props, headerData?.slug)}
					modal={() => setArchiveModal(true)}
					content='Are you sure, you want to Archive?'
					toggleModalFn={() => setArchiveModal(false)}
					confirmText="ARCHIVE"
				/>
				: null
			}
			{pageLoader ? <PageLoader/>: null}
		</Fragment>
	)
}

const mapStateToProps = (state) => ({
	aircraftTypes: state.shareReducer.aircraftTypes,
	engineTypes: state.shareReducer.engineTypes,
	lessees: state.shareReducer.lessees,
	operators: state.shareReducer.operators,
	regions: state.shareReducer.regions,
	portfolios: state.shareReducer.portfolios,
	pltConstants: state.shareReducer.pltConstants,
	aircraftMntGrp: state.shareReducer.aircraftMntGrp,
	leaseStatus: state.shareReducer.leaseStatus,
	subStatus: state.shareReducer.subStatus,
	allAssets: state.shareReducer.allAssets,
	basicDetailRefreshToken: state.shareReducer.basicDetailRefreshToken,
})

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		getAircraftTypes: (props, query) =>
			dispatch(getAircraftTypesAc(props, query)),
		getRegionList: () => dispatch(getRegionListAc()),
		getEngineTypes: (query) => dispatch(getEngineTypesAc(query)),
		getLesseeList: () => dispatch(getLesseeListAc()),
		getOperatorList: () => dispatch(getOperatorListAc()),
		getPortfolioList: () => dispatch(getPortfolioListAc()),
		getAircraftMntProgram: (aircraftId) =>
			dispatch(getAircraftMntProgramAc(aircraftId)),
		getPlatformConstants: () =>
			dispatch(getPlatformConstantsAc({ constant_types: ["asset_status", "credit_classification", "engine_position", "lg_position", "off_wing_status", "shop_visit_type", "workscope_status", "sv_report_status", "sv_requirement"], })),
		getLeaseStatus: () => dispatch(getLeaseStatus({ constant_types: ["lease_status"] })),
		getSubStatus: () =>
			dispatch(getSubStatus({ constant_types: ["asset_sub_status"] })),
		getAllAssetListFn: () => dispatch(getAllAssetListAc()),
	}
}

export default withRouter(withSnackbar(
	connect(mapStateToProps, mapDispatchToProps)(BasicDetailHeader))
)
